import type { ExpansionPanelState } from './cost-to-build-client-ui-expansion-panel.types';

export const EXPANSION_PANEL_INITIAL_STATE: ExpansionPanelState = {
    isOpen: true,
    number: 1,
    title: '',
};

export const areExpansionPanelStatesEqual = (left: ExpansionPanelState, right: ExpansionPanelState) =>
    left.isOpen === right.isOpen && left.number === right.number && left.title === right.title;
